# Nutrition : alimentation, portions et habitudes alimentaires

Ce que mange votre animal influence son énergie, son poids, son pelage et sa santé à long terme. Des portions régulières, des ingrédients de qualité et des repas à heures fixes font la plus grande différence.

<ArticleImage
  src="/images/guide/food-pet-bowl.jpg"
  alt="Bol de repas pour animal"
  caption="Les portions et la régularité comptent autant que les ingrédients."
/>

---

<Section emoji="⚖️" title="Portions & condition corporelle">

<Tip label="Mesurer les repas" text="Utilisez une mesure ou une balance pour éviter le surdosage progressif." />
<Tip label="Observer la silhouette" text="Les côtes doivent être palpables et la taille visible de dessus." />
<Tip label="Budget friandises" text="Limitez les friandises à moins de 10 % des calories quotidiennes." />

</Section>

<ArticleImage
  src="/images/guide/food-rabbit.jpg"
  alt="Repas équilibré"
  caption="Un bol équilibré comprend protéines, fibres et graisses essentielles."
/>

<Section emoji="🥩" title="Choisir la bonne alimentation">

<Tip label="Âge" text="Chiots, adultes et seniors ont des besoins nutritionnels différents." />
<Tip label="Santé" text="Les problèmes rénaux, allergies ou poids nécessitent souvent un suivi vétérinaire." />
<Tip label="Stabilité" text="Gardez une marque et une formule constantes pour éviter les troubles digestifs." />

<Callout>
Si vous envisagez une alimentation crue ou maison, demandez conseil à votre vétérinaire pour l’équilibre nutritionnel.
</Callout>

</Section>

<ArticleImage
  src="/images/guide/food-pet-water.jpg"
  alt="Verre d’eau"
  caption="L’hydratation soutient la digestion et la santé urinaire."
/>

<Section emoji="💧" title="Hydratation & friandises intelligentes">

<Tip label="Eau fraîche" text="Renouvelez l’eau chaque jour et ajoutez des bols dans les foyers multi‑animaux." />
<Tip label="Les chats et l’eau" text="La pâtée ou les fontaines peuvent aider les chats à boire davantage." />
<Tip label="À éviter" text="Éloignez chocolat, raisins/raisins secs, oignons et xylitol." />

</Section>

<Disclaimer title="⚠️ Petit rappel">
Ce guide est éducatif et ne remplace pas un avis vétérinaire. Toute perte d’appétit, vomissements ou diarrhée doit être discutée avec votre vétérinaire.
</Disclaimer>
